import React, { ChangeEvent, forwardRef } from "react"
import cn from "classnames"

import { InputProps } from "ui-kit/components-branded/FormControls/Input/types"
import style from "ui-kit/components-branded/FormControls/Input/Input.module.scss"

export const Input = forwardRef<HTMLInputElement, InputProps>(
    (
        {
            className,
            error,
            isMiddleSpacesAllowed = false,
            label,
            labelIcon,
            name,
            success,
            value,
            onChange,
            refLabel,
            testId = "input",
            ...props
        },
        ref
    ) => {
        const handleBlur = () => {
            return onChange && value && onChange(value.trim())
        }

        const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
            onChange?.(
                isMiddleSpacesAllowed
                    ? event.target.value.trimStart()
                    : event.target.value.replace(/\s+/g, "")
            )
        }

        return (
            <div className={cn(style.input, className)}>
                {label && (
                    <label
                        data-testid={`${testId}__input-label`}
                        className={style.input__label}
                        htmlFor={`input-${name}`}
                        ref={refLabel}
                    >
                        {labelIcon}
                        <span className={style.input__labelText}>{label}</span>
                    </label>
                )}
                <input
                    data-testid={`${testId}__input-field`}
                    id={`input-${name}`}
                    className={cn(style.input__field, { [style.input__field_error]: error })}
                    name={name}
                    ref={ref}
                    value={value}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    {...props}
                />
                {error && (
                    <div data-testid={`${testId}__input-error`} className={style.input__error}>
                        {error}
                    </div>
                )}
                {success && (
                    <div data-testid={`${testId}__input-success`} className={style.input__success}>
                        {success}
                    </div>
                )}
            </div>
        )
    }
)

Input.displayName = "Input"
